import default_warehouse from '@/assets/default_data/default_warehouse.json'
import default_brands from '@/assets/default_data/default_brands.json'
import default_discountPlan from '@/assets/default_data/default_discountPlan.json'
import default_categories from '@/assets/default_data/default_categories.json'

const getters = {
  sidebar: state => state.app.sidebar,
  language: state => state.app.language,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  roles: state => state.user.roles,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  changedViewEvent: state => state.tagsView.changedViewEvent,
  is_agency_enabled: state => state.shop.is_agency_enabled,
  shop_custom_host: state => state.shop.shop_custom_host,
  shop_domain_prefix: state => state.shop.shop_domain_prefix,
  is_coupon_enabled: state => state.shop.is_coupon_enabled,
  shop_id: state => state.user.shop_id,
  mobile_url: state => state.shop.mobile_url,
  ui_template_id: state => state.shop.ui_template_id,
  isShow_warehouses_badge: state => {
    // compare with default data to show badge or not
    const data = state.shop.warehouses
    if (data.length == 0) {
      return 'dot'
    } else if (data.length == 1) {
      if (data[0].address == default_warehouse[0].address) { return 'dot' } else { return null }
    } else { return null }
  },
  isShow_brands_badge: state => {
    // compare with default data to show badge or not
    const data = state.shop.brands
    if (data.length == 0) {
      return 'dot'
    } else if (data.length == 1) {
      if (data[0].brand_name == default_brands[0].brand_name) { return 'dot' } else { return null }
    } else { return null }
  },
  isShow_discountPlans_badge: state => {
    // compare with default data to show badge or not
    const data = state.shop.discountPlans
    if (data.length == 0) {
      return 'dot'
    } else if (data.length == 1) {
      if (data[0].name == default_discountPlan[0].name) { return 'dot' } else { return null }
    } else { return null }
  },
  isShow_categories_badge: state => {
    // compare with default data to show badge or not
    const data = state.shop.categories
    if (data.length == 0) {
      return 'dot'
    } else if (data.length == 1) {
      if (data[0].name == default_categories[0].name) { return 'dot' } else { return null }
    } else { return null }
  },
  isShow_MyPay_Setting: state => {
    const key = state.shop.my_pay_api_key
    const mid = state.shop.my_pay_mid
    if (key == null || mid == null) {
      return true
    }
    return false
  }
}
export default getters
